import styled from 'styled-components';

export const CompartmentsDrawerHeader = styled.div`
  margin-left: 10px;
  display: block;
  width: 100%;

  & .cargo {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    color: var(--neutral_light);
  }

  & h1 {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    display: inline-block;
    margin-bottom: 0px !important;
    margin-block-end: 0px !important;
    margin-block-start: 0px !important;
    text-transform: lowercase;
    &:first-letter {
      text-transform: uppercase;
    }
  }
  & span {
    margin-left: 10px;
    color: var(--neutral_medium);
  }
`;
